module.exports = __webpack_public_path__ + "static/img/case5.7498ca98.png";